import { render, staticRenderFns } from "./WidgetActualites.vue?vue&type=template&id=83ac2070&scoped=true&"
import script from "./WidgetActualites.vue?vue&type=script&lang=js&"
export * from "./WidgetActualites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac2070",
  null
  
)

export default component.exports